/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { Link, Text } from '@veeam/components';

import type { CSSProperties } from 'react';

import { BlankLine } from '../BlankLine';
import { ParagraphDivider } from '../ParagraphDivider';
import { TextDividerSymbols } from '../../../../helpers/text-parser';

import type { ConjunctionConfig, ParsedTextConfig, TextConfig } from '../../../../helpers/text-parser';

const listItemStyles: CSSProperties = {
    display: 'list-item',
    listStyleType: 'disc',
    listStylePosition: 'outside',
    marginLeft: '20px',
};

type ParsedTextConfigArray = Array<ParsedTextConfig[] | ParsedTextConfig>;

export interface TextFromConfigProps {
    textConfigs: ParsedTextConfig[];
}

export const TextFromConfig: React.FC<TextFromConfigProps> = ({ textConfigs }) => {
    const paragraphArr: ParsedTextConfigArray = textConfigs.reduce((res: ParsedTextConfigArray, textConfig: ParsedTextConfig) => {
        if (
            (textConfig as ConjunctionConfig).type === TextDividerSymbols.BlankLine
            || (textConfig as ConjunctionConfig).type === TextDividerSymbols.Paragraph
        ) {
            res.push(textConfig);
        } else {
            const lastItem = res[res.length - 1];

            if (!lastItem || (lastItem && (lastItem as ConjunctionConfig).type)) {
                res.push([]);
            }

            (res[res.length - 1] as TextConfig[]).push(textConfig as TextConfig);
        }

        return res;
    }, [[]]);
    const textContent: React.ReactElement<void>[] = paragraphArr.map((paragraph, index: number) => {
        if ((paragraph as ConjunctionConfig).type === TextDividerSymbols.BlankLine) {
            return <BlankLine key={`separator-${index}`} props={(paragraph as ConjunctionConfig).props} />;
        } else if ((paragraph as ConjunctionConfig).type === TextDividerSymbols.Paragraph) {
            return <ParagraphDivider key={`separator-${index}`} props={(paragraph as ConjunctionConfig).props} />;
        }

        const content: React.ReactElement<void>[] = (paragraph as TextConfig[])
            .map(({ text, props = {}, link, linkProps, listItem }, i) => {
                if (link) {
                    return <Link key={`${text}-${i}`} {...linkProps}>{text}</Link>;
                }

                return (
                    <Text
                        key={`${text}-${i}`}
                        asTag={'span'}
                        {...props}
                        style={{
                            display: 'inline',
                            ...props.style,
                            ...(props.asTag === 'b' ? { fontWeight: 'bold' } : {}),
                            ...(listItem ? listItemStyles : {}),
                        }}
                    >
                        {text}
                    </Text>
                );
            });

        return <Text key={`block-${index}`}>{content}</Text>;
    });


    return <Text>{textContent}</Text>;
};
